import { Box } from '@mui/material';
import ClassNames from 'classnames';
import React from 'react';

const getName = (name, newName, fileKey) => {
    if (name) {
        return name;
    }
    const folders = fileKey.split('/');
    return newName || folders[folders.length - 2];
};

const handleFolderClick = (event, browserProps, fileKey) => {
    event.stopPropagation();
    browserProps.select(
        fileKey,
        'folder',
        event.ctrlKey || event.metaKey,
        event.shiftKey
    );
};

export const TableFolder = ({
    browserProps,
    name,
    newName,
    depth,
    fileKey,
    isOpen,
    isSelected
}) => {
    const icon = browserProps.icons[isOpen ? 'FolderOpen' : 'Folder'];

    const nameToDisplay = getName(name, newName, fileKey);

    return (
        <tr
            className={ClassNames('folder', {
                selected: isSelected
            })}
            onClick={(event) => handleFolderClick(event, browserProps, fileKey)}
        >
            <td className="name" colSpan={4}>
                <div style={{ paddingLeft: `${depth * 16}px` }}>
                    <Box
                        as="a"
                        onClick={() => browserProps.toggleFolder(fileKey)}
                        className="link"
                    >
                        <Box alignItems="center" display="flex">
                            <Box mr="8px">{icon}</Box>
                            {nameToDisplay}
                        </Box>
                    </Box>
                </div>
            </td>
        </tr>
    );
};
